import { render, staticRenderFns } from "./HomeSoftware.vue?vue&type=template&id=054cbc66&"
import script from "./HomeSoftware.vue?vue&type=script&lang=js&"
export * from "./HomeSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports